import quotationService from '../service/quotation'
const state = {
    query: {
        customer: "",
        point: "",
        page: 1,
        pageSize: 10,
    },
    loading: false,
    searchResult: {
        total: 0,
        quotations: [],
    },
}

const actions = {
    createQuotation({ commit }, quotation) {
        return quotationService.createQuotation(quotation).then(data => {
            commit('setLoading', false)
            return data
        })
    },
    deleteQuotation({ commit }, id) {
        return quotationService.deleteQuotation(id).then(() => {
            commit('removeQuotation', id);
            return id;
        })
    },
    getQuotationHTML({ commit }, data) {
        commit('setLoading', true)
        return quotationService.getQuotationHTML(data)
            .finally(() => {
                commit('setLoading', false)
            })
    },
    getQuotations({ commit }, query) {
        commit('setLoading', true)
        return quotationService.getQuotations(query).then(quotations => {
            commit('setQuotations', quotations);
        }).catch(() => {
            commit('setLoading', false)
        })
    },

}
const mutations = {
    addQuotation(state, quotation) {
        state.searchResult.quotations.push(quotation)
    },
    removeQuotation(state, id) {
        var index = state.searchResult.quotations.findIndex(x => x._id == id)
        if (index) {
            state.searchResult.quotations.splice(index, 1)
        }
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setQuotations(state, quotations) {
        state.searchResult = quotations
        state.loading = false
    },

}
export default {
    namespaced: true,
    state,
    actions,
    mutations
}



